import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import ReactPlayer from 'react-player';

import { Play } from 'react-feather';
import ReactLoading from 'react-loading';

export default class UpdoxVideoPlayer extends Component {
  static propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sourceUrl: PropTypes.string,
    previewUrl: PropTypes.string,
    onFetchSource: PropTypes.func,
    isDownloading: PropTypes.bool,
  };

  state = {
    isPlayClicked: false,
  };

  onPlay = () => {
    const { onPlayClicked } = this.props;
    onPlayClicked && onPlayClicked();
    this.setState({ isPlayClicked: true });
  };

  render() {
    const { isPlayClicked } = this.state;
    const { sourceUrl, previewUrl, width, height, isDownloading } = this.props;

    if (!isEmpty(previewUrl) && (!isPlayClicked || isEmpty(sourceUrl))) {
      return (
        <VideoPreview
          width={width}
          height={height}
          isDownloading={isDownloading}
          previewUrl={previewUrl}
          onPlayClicked={this.onPlay}
        />
      );
    }

    return (
      <ReactPlayer
        className="video-react-player"
        url={sourceUrl}
        width={width}
        height={height}
        controls={true}
        playing={isPlayClicked}
      />
    );
  }
};

const VideoPreview = ({ width, height, isDownloading, previewUrl, onPlayClicked }) => (
  <div style={{ width: width, height: height }} className="video-preview-container" onClick={onPlayClicked}>
    { previewUrl && <div className="video-preview-image" style={{ backgroundImage: `url(${previewUrl})` }}>&nbsp;</div> }
    { isDownloading ? <VideoLoading/> : previewUrl && <PlayButton/> }
  </div>
);

const VideoLoading = () => (
  <ReactLoading className="video-loading" type="spin" color="#FFF" height={36} width={36}/>
);

const PlayButton = () => (
  <div className="video-play-button">
    <Play size={24}/>
  </div>
);
